// extracted by mini-css-extract-plugin
export default {"fullscreenblack":"Thesis_fullscreenblack__fGFDQ","flashing":"Thesis_flashing__X1-kB","anim":"Thesis_anim__z-pYR"};